<template>
  <header>
    <div class="container">
      <nav id="as-header" ref="header">
        <div id="logo">
          <router-link :to="{ name: 'home', query: { _page: '1', _perPage: '10' } }">
            <Logo class="logo" />
            <LogoMobile class="logoMobile" />
          </router-link>
        </div>

        <div id="actions">
          <!-- <div id="links-btn" v-if="$store.getters.isLogged()">
            <button v-if="!$store.getters.firstAccess" @click="handleDrop('links-btn')">
              {{ parseTranslation(QUICK_LINKS) }}
            </button>

            <div id="account-dropdown">
              <h3>Links</h3>

              <a target="_blank" :href="`${reporttool}?token=${$store.getters.token}`"
                >Report</a
              >

              <router-link id="media" to="/medialibrary">{{
                translations[language][MEDIA_LIBRARY]
              }}</router-link>
            </div>
          </div> -->

          <div id="language">
            <button @click="handleDrop('language')" class="current-language">
              <Language />
              <p>
                {{ parseTranslation(CURRENT_LANGUAGE) }}
              </p>
            </button>

            <div class="language-dropdown">
              <h3>{{ parseTranslation(LANGUAGE) }}</h3>

              <button
                v-for="appLanguage in languages"
                :key="appLanguage"
                @click="setLanguage(appLanguage)"
                :class="{ mode: language === appLanguage }"
              >
                {{ translations[appLanguage][CURRENT_LANGUAGE] }}
              </button>
            </div>
          </div>

          <div id="account-btn" v-if="$store.getters.isLogged()">
            <button @click="handleDrop('account-btn')">
              <Account />
            </button>

            <div id="account-dropdown-preferences">
              <h3 v-if="!$store.getters.firstAccess">
                {{ parseTranslation(PREFERENCES) }}
              </h3>

              <button
                v-if="!$store.getters.firstAccess"
                :class="{ mode: $store.getters.darkmode }"
                @click="toggleVizMode"
              >
                {{ parseTranslation(DARK_MODE) }}
              </button>

              <button
                v-if="!$store.getters.firstAccess"
                :class="{ mode: !$store.getters.darkmode }"
                @click="toggleVizMode"
              >
                {{ parseTranslation(LIGHT_MODE) }}
              </button>

              <h3>{{ parseTranslation(ACCOUNT) }}</h3>

              <router-link
                v-if="$store.getters.isLogged() && !$store.getters.firstAccess"
                :to="{ name: 'password' }"
                id="admin"
              >
                {{ parseTranslation(MY_ACCOUNT) }}
              </router-link>

              <button v-if="$store.getters.isLogged()" @click="logOut" id="logout">
                {{ parseTranslation(LOGOUT) }}
              </button>
            </div>
          </div>

          <router-link v-if="$route.path === '/reset'" :to="{ name: 'login' }" id="login">
            {{ parseTranslation(LOGIN) }}
          </router-link>
        </div>
      </nav>
    </div>
    <div class="header-shadow"></div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Language from '@/components/imgs/Language'
import Account from '@/components/imgs/Account'
import Logo from '@/components/imgs/Logo'
import LogoMobile from '@/components/imgs/LogoMobile'

import { LANGUAGES } from '@/utils/constants'

import * as translationHeader from './Header.translations'

const { default: translations, ...translationKeys } = translationHeader

const languages = Object.values(LANGUAGES)

export default {
  name: 'as-header',

  components: { Language, Account, Logo, LogoMobile },

  data() {
    return {
      toggleLanguageDropdown: false,
      translations,
      ...translationKeys,
      languages,
    }
  },

  computed: {
    ...mapGetters(['darkmode']),
  },

  methods: {
    ...mapActions([
      'tabBilling',
      'sendMessage',
      'surveyRemove',
      'logout',
      'toggleDarkMode',
      'executeSurveyAPICall',
      'toggleLanguage',
    ]),

    setLanguage(language) {
      this.toggleLanguage(language)
    },

    goToBilling() {
      this.tabBilling(0)
      this.$router.push({ name: 'billing' })
    },

    logOut() {
      this.surveyRemove()
      this.logout()
      this.$router.push({ name: 'login' })
    },

    toggleVizMode() {
      this.toggleDarkMode(!this.darkmode)
    },

    handleDrop(drop) {
      const dropItem = document.querySelector(`#${drop}`)
      dropItem.children[1].classList.toggle('active')

      this.outsideClick(dropItem, ['click'], () => {
        dropItem.children[1].classList.remove('active')
      })
    },

    outsideClick(element, events, callback) {
      const html = document.documentElement
      const outside = 'data-outside'

      if (!element.hasAttribute(outside)) {
        events.forEach(userEvent => {
          setTimeout(() => {
            html.addEventListener(userEvent, e => {
              if (!element.contains(event.target)) {
                element.removeAttribute(outside)
                events.forEach(userEvent => {
                  html.removeEventListener(userEvent, this.handleOutsideClick)
                })
                callback()
              }
            })
          })
        })
        element.setAttribute(outside, '')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
header {
  position: relative;
}
.header-shadow {
  width: 100%;
  height: 4px;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.3);
}

.logoMobile {
  display: none;
}

#top-header {
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 15px;
  }
  border-bottom: 2px solid $gray-3;
}

#top-header-links {
  display: flex;
  align-items: flex-start;
  a {
    @include tipography(15);
    text-transform: uppercase;
    font-weight: 600;
    color: $gray-2;
    padding: 0 10px;
    img {
      margin-left: 5px;
    }
  }
  .active {
    color: white;
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -12px;
      left: calc(50% - 2.5px);
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: $blue;
    }
  }
}

#as-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 10px;
}

#header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#actions {
  display: flex;
  justify-content: space-around;
  > div {
    margin: 0 10px;
  }
  > button {
    @include tipography(15);
    @include transparentButton;
    padding: 10px;
    font-weight: bold;
    width: 100px;
    @include d(m) {
      padding: 7px;
    }
    color: $gray;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: pointer;
    &:hover {
      color: $white;
      &::after {
        min-width: 100%;
        color: $secondary-two;
      }
    }
    &::after {
      content: '';
      height: 2px;
      width: auto;
      min-width: 0px;
      color: transparent;
      background-image: linear-gradient(
        to right,
        transparent,
        currentColor 50%,
        transparent
      );
      display: block;
      border-radius: 3px;
      position: relative;
      top: 5px;
      transition: min-width 0.35s cubic-bezier(0.05, 0.385, 0.32, 1.275);
    }
    &.router-link-exact-active,
    &.router-link-active {
      color: $white;
      &::after {
        @include d(s) {
          color: transparent;
        }
        color: $secondary-two;
        min-width: 100%;
      }
    }
    &[href='/'].router-link-active {
      color: $gray;
      &::after {
        @include d(s) {
          color: rgba(0, 0, 0, 0);
        }
        color: $secondary-two;
        min-width: 0px;
      }
      &:hover {
        &::after {
          min-width: 100%;
        }
      }
      &.router-link-exact-active {
        color: $white;
        &::after {
          @include d(s) {
            color: transparent;
          }
          color: $secondary-two;
          min-width: 100%;
        }
      }
    }
  }
}

#links-btn,
#account-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    @include transparentButton;
    &:focus {
      outline: none;
    }

    svg {
      @include boxSizing(21);
    }
  }
  @include d(s) {
    width: unset;
  }
}

#links-btn {
  button {
    white-space: nowrap;
    padding: 0 10px;
    @include tipography(16);
    .light & {
      color: $gray-6;
    }
  }
}

#account-dropdown,
#account-dropdown-preferences {
  background: rgb(105, 105, 105);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  position: absolute;
  z-index: 5;
  top: 50px;
  padding: 10px;
  width: 155px;
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;
  display: none;
  &.active {
    display: block;
  }
  h3 {
    @include tipography(15);
    color: $gray-5;
    display: flex;
    align-items: flex-end;
    margin-bottom: 10px;
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: $gray-5;
    }
  }
  button,
  a {
    display: block;
    padding: 5px 0;
    cursor: pointer;
    @include tipography(15);
    @include transparentButton;
    justify-content: flex-start;
    text-transform: uppercase;
    &.mode {
      color: $blue-2;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      &::after {
        content: '';
        display: block;
        width: 5px;
        height: 5px;
        background: $blue-2;
        border-radius: 50%;
        margin-left: 5px;
      }
    }
  }
}

#language {
  position: relative;
  @include flexMiddle;

  button {
    svg {
      @include boxSizing(21);
    }

    &:focus {
      outline: none;
    }
    @include transparentButton;

    p {
      margin-left: 5px;
      @include tipography(15);

      .light & {
        color: black;
      }
    }
  }

  .language-dropdown {
    background: rgb(105, 105, 105);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    position: absolute;
    z-index: 5;
    top: 50px;
    padding: 10px;
    width: 155px;
    animation: growDown 400ms ease-in-out forwards;
    transform-origin: top center;
    display: none;

    &.active {
      display: block;
    }

    h3 {
      @include tipography(15);
      color: $gray-5;
      display: flex;
      align-items: flex-end;
      margin-bottom: 10px;
      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: $gray-5;
      }
    }

    button {
      display: block;
      padding: 5px 0;
      cursor: pointer;
      @include tipography(15);
      @include transparentButton;
      justify-content: flex-start;
      text-transform: uppercase;
      &.mode {
        color: $blue-2;
        display: flex;
        align-items: center;
        transition: all 0.3s ease;
        &::after {
          content: '';
          display: block;
          width: 5px;
          height: 5px;
          background: $blue-2;
          border-radius: 50%;
          margin-left: 5px;
        }
      }
    }
  }
}

@media (max-width: 1229.98px) {
  #account-dropdown-preferences {
    right: 0;
  }
}

@media (max-width: 575.98px) {
  .logo {
    display: none;
  }
  .logoMobile {
    display: block;
  }
}

@media (max-width: 400px) {
  .current-language {
    p {
      display: none;
    }
  }
}
</style>
